export default __webpack_public_path__ + "static/media/Avatar.32b7a9a4.svg";